import { inject } from '@angular/core';
import { MetaDefinition } from '@angular/platform-browser';
import { ResolveFn } from '@angular/router';
import { AssetDto, TenantDto } from '@nusign/picflow-backend-types';
import { firstValueFrom } from 'rxjs';
import { calcResizedUrl } from '../../lib/calc-resized-url';
import { getMetaImageTags, getMetaTitleTags } from '../../lib/meta-helpers';
import { PICFLOW_CONFIG } from '../../picflow-config';
import { AssetService } from '../../services/asset.service';
import { GalleryService } from '../../services/gallery.service';
import { getTitle } from './public-gallery-page-meta.resolver';

export const publicAssetPageMetaResolver: ResolveFn<{ title: string; tags: MetaDefinition[] }> = async route => {
  const galleryService = inject(GalleryService);
  const assetService = inject(AssetService);
  const config = inject(PICFLOW_CONFIG);

  const gallery = await galleryService.getPublicGalleryFromSnapshot(route);
  const assetId = route.params.assetId.replace('}', '');
  let asset: AssetDto;

  try {
    asset = await firstValueFrom(assetService.getAsset(assetId, gallery.id, { allowCache: true }));
  } catch {}
  if (!asset) return;

  const galleryTitle = getTitle(gallery, gallery.tenant as TenantDto);
  const title = `${galleryTitle} · ${asset.name}`;

  return {
    title,
    tags: [
      ...getMetaTitleTags(title),
      ...getMetaImageTags(
        calcResizedUrl(
          config.assetsEndpoint,
          asset,
          asset.version_data,
          `1200x630`,
          gallery.watermark && asset.watermark_enabled
        )
      ),
      {
        name: 'theme-color',
        content: '#000000',
      },
    ],
  };
};
